import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Table as BootstrapTable } from 'reactstrap';
import styles from './styles.scss';

class Table extends React.Component {
  get headers() {
    const { headers, sortable, sortableHeaders, sortAction, sortedColumn, sortAsc } = this.props;
    if (sortable) {
      return sortableHeaders.map((header, index) => {
        return (
          <th
            onClick={() => {
              header[0] ? sortAction(header[1]) : '';
            }}
            className={!!header[0] ? `${styles.searchHeaderCell}` : `${styles.searchHeaderEmptyCell}`}
            scope="col"
            key={index}
          >
            <div
              className={
                header[0]
                  ? `${styles.sorting}${
                      sortedColumn === header[1]
                        ? sortAsc
                          ? sortedColumn === 'Status'
                            ? '_desc'
                            : '_asc'
                          : sortedColumn === 'Status'
                          ? '_asc'
                          : '_desc'
                        : ''
                    }`
                  : ''
              }
            >
              {header[0]}
            </div>
          </th>
        );
      });
    }

    return headers.map((header, index) => {
      return (
        <th className={!!header ? `${styles.headerCell}` : `${styles.headerEmptyCell}`} scope="col" key={index}>
          {header}
        </th>
      );
    });
  }

  get rows() {
    const { rows } = this.props;
    return rows.map((row, index) => (
      <tr key={index}>
        {row.map((data, index) => (
          <td className={!!data ? `${styles.tableCell}` : `${styles.emptyCell}`} key={index}>
            {data}
          </td>
        ))}
      </tr>
    ));
  }

  render() {
    const { responsive, bordered, withActionColumn } = this.props;
    const responsiveClasses = classNames(styles.responsive, {
      'table-responsive': responsive,
    });

    return (
      <div className={responsiveClasses}>
        <BootstrapTable
          bordered={bordered}
          className={classNames(`text-center ${styles.table}`, {
            [styles.actionColumn]: withActionColumn,
          })}
        >
          <thead className="thead-light">
            <tr className={`${styles.tableHeader}`}>{this.headers}</tr>
          </thead>
          <tbody>{this.rows}</tbody>
        </BootstrapTable>
      </div>
    );
  }
}

Table.propTypes = {
  headers: PropTypes.array,
  rows: PropTypes.array,
  responsive: PropTypes.bool,
  bordered: PropTypes.bool,
  withActionColumn: PropTypes.bool,
  sortable: PropTypes.bool,
  sortableHeaders: PropTypes.array,
  sortAction: PropTypes.func,
  sortedColumn: PropTypes.string,
  sortAsc: PropTypes.bool,
};

Table.defaultProps = {
  headers: [],
  rows: [],
  responsive: true,
  bordered: true,
  withActionColumn: true,
  sortable: false,
  sortableHeaders: [],
  sortAction: () => {},
  sortedColumn: '',
  sortAsc: true,
};

export default Table;



// WEBPACK FOOTER //
// src/components/shared/Table/index.jsx